import { useLDClient } from 'launchdarkly-react-client-sdk';

export const GENERIPAY_FLAG = 'fintech.retail-payments.pos.generipay.rollout';

export function useGeneriPayFlag() {
  const ldClient = useLDClient();
  return ldClient?.variation(GENERIPAY_FLAG, false);
}
